import React from 'react'

const Ccc = () => {
  return (
    <div>
    <div className="row" style={{ backgroundColor: 'black'}}>
                               <div className="col-md-1 col-sm-6 col-xs-12">
                                </div>
                                <div className="col-md-4 col-sm-6 col-xs-12  Footer-box">
                                    <h4 style={{color: 'white'}}>
                                        National Informatics Centre (NIC)
                                    </h4>
                                    <p className="text" style={{marginTop: '10px', color: 'white'}}>
                                        National Informatics Centre (NIC) was established in 1976, and has since emerged
                                    as a "prime builder" of e-Government / e-Governance applications up to the grassroots
                                    level as well as a promoter of digital opportunities for sustainable development.
                                    <a href="http://www.nic.in/" target="_blank" style={{color: 'white', fontStyle: 'italic', textDecoration: 'underline'}}>More Info...</a>
                                    </p>
                                </div>
                                <div className="col-md-3 col-sm-6 col-xs-12 Footer-box">
                                    <h4 style={{color: 'white'}}>
                                        Useful Links
                                    </h4>
                                    <ul>
                                        <li>1.&nbsp;<a href="https://nsp.gov.in/" target="_blank" style={{color: 'White'}}>National
                                        Scholarship Portal</a></li>
                                        <li>2.&nbsp;<a href="https://state.bihar.gov.in/educationbihar/CitizenHome.html" target="_blank" style={{color: 'White'}}>Education Department Website</a></li>
                                        <li>3.&nbsp;<a href="https://medhasoft.bih.nic.in/" target="_blank" style={{color: 'White'}}>MedhaSoft</a></li>
                                    </ul>
                                </div>
                                <div className="col-md-4 col-sm-6 col-xs-12 Footer-box">
                                    <h4 style={{color: 'white'}}>
                                        Helpdesk
                                    </h4>
                                    <p>
                                        <a href="tel:+91-9534547098" style={{color: 'White'}}><span className="glyphicon glyphicon-earphone" aria-hidden="true" style={{color: 'White'}}></span>+91-9534547098 ( Raj Kumar )</a><hr/>                                      
                                        <a href="tel:+91-8986294256" style={{color: 'White'}}><span className="glyphicon glyphicon-earphone" aria-hidden="true" style={{color: 'White'}}></span>+91-8986294256 ( INDRAJEET )</a><hr/></p>
                                    <p style={{textAlign: 'left'}}>For any query and suggestion mail us on <b>postmatricbiharhelp2022@gmail.com</b></p>
                                </div>
                            </div>
                            </div>
    
    
  )
}

export default Ccc
